import ApplicationController from './application_controller';

// Live "Sign N sessions" count for the sign-by-link page. Mounted on the form,
// it listens for any checkbox input that bubbles up — per-row toggles and the
// select-all master (which dispatches input events) — recounts the checked
// entries, updates the submit label, and disables submit at zero. Server-side
// "select at least one" guard remains the backstop if JS doesn't run.
export default class extends ApplicationController {
  static targets = ['output', 'submit'];

  connect() {
    this.update();
  }

  update() {
    const count = this.element.querySelectorAll('input[name="entry_ids[]"]:checked').length;

    if (this.hasOutputTarget) {
      this.outputTarget.textContent =
        count === 0 ? 'Sign selected sessions' : `Sign ${count} ${count === 1 ? 'session' : 'sessions'}`;
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = count === 0;
    }
  }

  // Guard against a double-tap on the full-page (turbo: false) submit: disable
  // the button and show progress. The form still submits; this only blocks a
  // second POST. On a server-side validation failure the page re-renders and
  // connect() -> update() restores the button, so it can't get stuck disabled.
  submitting() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true;
    }
    if (this.hasOutputTarget) {
      this.outputTarget.textContent = 'Signing...';
    }
  }
}
